import { CANONICAL_COLUMNS } from "./Columns";
import { validateStripePaymentLink } from "./Validations";

export const separateRowsByPaymentLink = (data) => {
  const validRows = [];
  const invalidRows = [];

  const hasPaymentLinkColumn =
    data.length > 0 && CANONICAL_COLUMNS.STRIPE_LINK in data[0];

  if (!hasPaymentLinkColumn) {
    return { validRows: data, invalidRows: [] };
  }

  data.forEach((row, index) => {
    const paymentLink = row[CANONICAL_COLUMNS.STRIPE_LINK] || "";
    const validation = validateStripePaymentLink(paymentLink);

    if (validation.isValid) {
      validRows.push(row);
    } else {
      invalidRows.push({
        row,
        rowNumber: index + 2,
        error: validation.error,
        partInfo: `${row[CANONICAL_COLUMNS.YEAR]} ${
          row[CANONICAL_COLUMNS.MAKE]
        } ${row[CANONICAL_COLUMNS.MODEL]} - ${row[CANONICAL_COLUMNS.PART_NAME]}`
      });
    }
  });

  return { validRows, invalidRows };
};
